import { useQuery, gql } from '@apollo/client';
import React, { FC } from 'react';

import CityList from '../CityList/CityList';

type BigCity = {
  id: string;
  slug: string;
  name: string;
};

type BigCitiesResponse = {
  bigCities: BigCity[];
};

type Props = {
  categorySlug: string;
  categoryName: string;
  multiColumn?: boolean;
  isL2?: boolean;
};

const BigCitiesQuery = gql`
  query BigCities {
    bigCities(limit: 80) {
      id
      slug
      name
    }
  }
`;

const BigCities: FC<Props> = (props) => {
  const { categorySlug, categoryName, multiColumn, isL2 } = props;
  const { data, loading } = useQuery<BigCitiesResponse>(BigCitiesQuery);

  if (!data || loading) {
    return null;
  }

  const { bigCities } = data;

  return (
    <CityList
      cities={bigCities}
      categorySlug={categorySlug}
      categoryName={categoryName}
      multiColumn={multiColumn}
      isL2={isL2}
      showAllCitiesLink
    />
  );
};

export default BigCities;
